import { useRef } from 'react';
import Loading from '@components/Loading/Loading';
type PropsType = {
  video: string;
  isPlaying: boolean;
  isLoading: boolean;
  loop: boolean;
  onPlay: () => void;
  onLoad: () => void;
  onEnded?: () => void;
  controls?: boolean;
};
const YouTubePlayer = ({
  video,
  isPlaying,
  isLoading,
  loop,
  onPlay,
  onLoad,
  controls = false
}: PropsType) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const getYouTubeUrl = () => {
    if (video.startsWith('http')) {
      return video;
    }
    return `https://www.youtube.com/embed/${video}`;
  };
  const getYouTubeVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };
  const videoId = getYouTubeVideoId(video);
  const baseUrl = getYouTubeUrl();

  // Parametry dla YouTube iframe
  const params = new URLSearchParams({
    autoplay: isPlaying ? '1' : '0',
    controls: controls ? '1' : '0',
    mute: '1',
    loop: loop ? '1' : '0',
    playsinline: '1',
    rel: '0',
    showinfo: '0',
    modestbranding: '1'
  });

  // Dla loop dodajemy playlist z tym samym video ID
  if (loop && videoId) {
    params.append('playlist', videoId);
  }
  const iframeSrc = `${baseUrl}?${params.toString()}`;
  return <div style={{
    position: 'relative',
    width: '100%',
    height: '100%'
  }}>
      {isLoading && <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1
    }}>
          <Loading />
        </div>}

      {!isPlaying && !isLoading && <button type="button" onClick={onPlay} style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.5)',
      border: 'none',
      borderRadius: '50%',
      width: '80px',
      height: '80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 2
    }}>
          <div style={{
        width: 0,
        height: 0,
        borderLeft: '20px solid white',
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        marginLeft: '4px'
      }} />
        </button>}

      <iframe ref={iframeRef} src={iframeSrc} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen role="presentation" style={{
      width: '100%',
      height: '100%',
      border: 'none',
      display: isLoading ? 'none' : 'block'
    }} onLoad={onLoad} title="YouTube video player" />
    </div>;
};
export default YouTubePlayer;